import React, {useState, useEffect} from 'react'
import Template from '../component/template'
import {LoadEffect}  from '../component/loader'
import axios from 'axios'
import { Alerts } from '../component/notify'
import PageHeader from '../component/pageheader'
import {ServerUrl, Token, config } from '../component/include'


 const UploadBooks=()=> {
    const [notice, setNotice] = useState({
        isLoading : false, 
        isDataFetching: false,
    });

const [csvFile, setCsvFile]=useState({
    booksCsv:'',
    fileName:'Please select .csv files (allowed file size 500KB)'
})

const [errors, setErrors] = useState({});


const  handleSubmit=(event)=>{ 
    event.preventDefault(); 
    if(!csvFile.booksCsv){
        errors.booksCsv ='You have not choose any file to upload';
        Alerts('Error!', 'danger', errors.booksCsv)
    }else{

    
    let formData = csvFile;
    
    const fd = new FormData();
    
    fd.append('jwt', Token);
    //fd.append('bookList', JSON.stringify(bookList, null, 2));
     for(let k in formData){
        fd.append(k,formData[k]);
    };  
     setNotice({...notice,   isLoading: true}) 
       let url = ServerUrl+'/save_controller/importBooks'
      axios.post(url, fd, config).then(response =>{
        if (response.data.type ==='success'){
			Alerts('Saved!', 'success', response.data.message)
		} else if (response.data.type ==='info'){
            Alerts('Saved!', 'default', response.data.message)
            
        }else{
			Alerts('Error!', 'danger', JSON.stringify(response.data))
	}  
	})
	.catch((error)=>{
		Alerts('Error!', 'danger', JSON.stringify(error.message)) 
	})
	.finally(()=>{
	  setNotice({...notice, isLoading: false}) 
     setCsvFile({...csvFile, booksCsv:'', fileName:'Please select .csv files (allowed file size 500KB)'}); 
     document.getElementById('booksCsv').value=''
}) 
}
 }

    const  handleFile = function(fieldName){
        return function(newValue){  
           
            setErrors({...errors, [fieldName]:''})
       readURL(newValue);
       }
       
    } 
   

    const readURL = (input)=>{
       
        let displayMessage = '';
        const PreviewImage = input.target.name;
            var fileName = document.getElementById(PreviewImage).value;
        var idxDot = fileName.lastIndexOf(".") + 1;
        var extFile = fileName.substr(idxDot, fileName.length).toLowerCase();
        

        if (extFile==="csv" || extFile==="CSV"){
            //TO DO    
            
             var FileSize = input.target.files[0].size / 1024 / 1024; // in MB
        if (FileSize > 0.5) {
            displayMessage = ' File uploaded is more than maximum size Allow. it exceeds 500 Kb';
           document.getElementById(input.target.name).value = '';
        } else {
            if (input.target.files && input.target.files[0]) { //Check if input has files.
                   const value = input.target.files[0]
            setCsvFile({...csvFile, booksCsv:value, fileName:value.name})
           
            }
        }
        }else{

            displayMessage = 'Only csv|CSV  files are allowed with maximum of 500kb'
            document.getElementById(input.target.name).value = '';
            setCsvFile({...csvFile, booksCsv:'', fileName:'Please select .csv files (allowed file size 500KB)'})
        }  
        
        if(displayMessage.length > 0){
            Alerts('Error!', 'danger', displayMessage)
          }
        
    } 



        return (  
   <>{notice.isLoading ?<LoadEffect className="overlay floatLoad" /> : "" }
   <div  className="main-body">
                <div className="page-wrapper">

                   {/* <!-- Page-header start --> */}

        <PageHeader title="Library Books">
        <li className="breadcrumb-item"><a  href="#!"> <i className="fa fa-fw fa-book"></i> </a>
                            </li>
                    <li className="breadcrumb-item"><a href="#!">Library</a> </li>
                    <li className="breadcrumb-item"><a href="#!">Upload books</a> </li>
                    </PageHeader>
{/* The Page Body start here */}
                <div className="page-body">
                <div className="row  ">
	<div className="col-sm-12">
	<div className="card z-depth-0">
		<div className="card-header">
			<h5>Prepare your books file</h5>
			<div className="card-header-right">
				<ul className="list-unstyled card-option">
					<li><i className="feather icon-maximizes full-card"></i></li>
					<li><i className="feather icon-minus minimize-card"></i></li>
					<li><i className="feather icon-trash-2 close-card"></i></li>
				</ul>
			</div>
		</div>
		<div className="card-block" >
                    <div className="well">
                       
                        <div className="box-body">
                        <div className="row">
                            <div className="col-sm-3 text-right  text-danger"><u><b>Required Columns</b></u></div>
                            <div className="col-sm-7"><u><b>Allowed Values</b></u></div>                           
                        <div className="col-sm-3 text-right "><b>Book Name</b></div>
                    <div className="col-sm-7">Title of Materials<br/>                       </div>          								
                            <div className="col-sm-3 text-right "><b>Author's Name</b></div>
                        <div className="col-sm-7">Book Author      <br/>  </div>    
                        <div className="col-sm-3 text-right "><b>Publisher</b></div>
                        <div className="col-sm-7">Book Publisher      <br/>  </div> 



                        <div className="col-sm-3 text-right "><b>Class Mark</b></div>
                        <div className="col-sm-7">Classification Mark      <br/>  </div> 

                        <div className="col-sm-3 text-right "><b>Access No</b></div>
                        <div className="col-sm-7">Access Number     <br/>  </div> 


                        <div className="col-sm-3 text-right "><b>Publisher Year</b></div>
                        <div className="col-sm-7">Year of Publication     <br/>  </div> 


                        <div className="col-sm-3 text-right "><b>ISBN</b></div>
                        <div className="col-sm-7">ISBN     <br/>  </div> 


                                                
                           
                            <div className="col-sm-3 text-right  text-warning"><u><b>Optional Columns</b></u></div>
                            <div className="col-sm-7 "><u><b>Allowed Values</b></u></div>   


                            <div className="col-sm-3 text-right "><b>Barcode</b></div>
                     <div className="col-sm-7">The Book Barcode<br/>                       
                                </div>

                                <div className="col-sm-3 text-right "><b>Subject Code</b></div>
                            <div className="col-sm-7">Book Subject Identity                    <br/></div>   


                    <div className="col-sm-3 text-right "><b>Purpose Code</b></div>
                    <div className="col-sm-7">Book Purpose Code<br/>      <br/>                    
                                </div> 

                                <div className="col-sm-3 text-right "><b>Price</b></div>
                     <div className="col-sm-7">The Book Cost Price<br/>                       
                                </div>


                                <div className="col-sm-3 text-right "><b>Remark</b></div>
                     <div className="col-sm-7">The Librerian Remark<br/>                       
                                </div>


                        </div>
                    </div>
                </div>
	</div>
    </div>

</div>
</div>


                <div className="row  ">
								<div className="col-sm-6">
	<div className="card z-depth-0">
		<div className="card-block">
		<fieldset>
			<div className="row">
									
			<section className="col-md-12 ">
			<div className="well well-sm alert alert-success border-success background-success ">
					<h4 className="alert-heading ">Download Sample File</h4>
					
<p><span >The first line in downloaded csv file should remain as it is. Please do not change the order of columns.</span><br/>
<span >The correct column order is (<b>
    TITLE OF MATERIALS, AUTHORS NAME, PUBLISHER, CLASS. MARK, ACCESS NO, YEAR OF PUB., I.S.B.N, PRICE, Subject ID, Purpose ID, Barcode, Remark </b>)</span> <span >&amp; you must follow this.</span></p>
					<hr className="simple" /><p className="text-align-left">
						
                    <form method='POST' action={ServerUrl+'/csvSample_controller/books'} target='_blank'>
                <input type='hidden' name='jwt' value ={Token} />
                
        <button type="submit" className="btn btn-sm btn-inverse"> <i className="fa fa-download"></i> Download Sample</button>
        
        </form>

					</p>
				</div>					
				</section>
										</div>
										
				</fieldset>
				
							</div>
							</div>
							</div>
		
	
	

	<div className="col-sm-6">
	<div className="card z-depth-0">
	
		<div className="card-block">


		<div className="alert alert-success border-success">
						<fieldset className="well well-sm">
                        <h4 className="alert-heading ">Upload file with .csv extention</h4>
							<section>
                            <div className="form-group">
							<label  className={errors.booksCsv  ? 'btn btn-sm btn-danger' : 'btn btn-sm btn-inverse'}  htmlFor="booksCsv" > <i className="fa fa-upload"></i>Choose File </label>
                    <input id="booksCsv"  onChange={handleFile('booksCsv')} className="form-control file" name="booksCsv" type="file" accept=".csv" /> 
						<div className="note" style={{color:'red'}}>
			{csvFile.fileName}
		</div>	
										</div>          
                                        
							</section>
						</fieldset><span style={{color:'red'}}>{errors.booksCsv && errors.booksCsv}</span></div><br/><br/>
						<footer>
							<button type="button" id="submit" onClick={handleSubmit} className="btn  btn-primary pull-right"><i className="fa fa-save"></i> Upload Library Books</button>
						</footer>

	</div>

</div>

</div></div>
	
		

                </div>
          {/* The Page Body close here */}

            </div>
            </div>

</> 
 );
        
}

export default React.memo(UploadBooks) 